import { BiArrowToRight } from "react-icons/bi";
import { BsAwardFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import ReactTyped from "react-typed";
import Faq from "./components/Faq";
import Layout from "./Layout";
import Loader from "./components/Loader";
import { useEffect, useState } from "react";

const Home = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {

        const delay = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => clearTimeout(delay);
    }, []);
    return (
        <>
            {loading ? (
                <Loader /> // Display the loader while loading
            ) : (

                <Layout>

                    <div className="bg-blue-100 text-[#0a1a42] md:flex max-[780px]:px-4 pt-12 md:pt-22 md:px-8 md:place-items-center">
                        <div className="md:w-2/4">

                            <ReactTyped
                                className="text-2xl font-bold mx-auto block text-center font-roboto"
                                strings={['You are Welcome']}
                                typeSpeed={40}
                            />

                            <h2 className="text-[18px] pt-4 leading-8">
                                Our primary aim is to help our students identify their innate potential and skills, hone them, and help each child utilize them to positively affect their environment. We
                                believe the best form of education is a personalized one that gives the individual child the rare opportunity to explore their creativity, build confidence and character, understand their environment, and be the positive change the society desires.
                                I am very certain our standards and professional conduct will exceed your expectations and together we can all achieve more.
                            </h2>
                            <button className=" mx-auto block bg-[#f7951e] text-white mt-4 px-8 py-2">View Gallary and Facilties</button>
                        </div>

                        <div>
                            <img src="/people/poster2.png" alt=""
                                className=" "
                            />
                        </div>
                    </div>

                    <div className="mt-8 md:mt-24 text-center max-[780px]:px-4 md:px-8 md:flex md:place-items-center">
                        <div >
                            <img src="/schoolweb/excutive.webp"
                                className="w-3/4 mx-auto"
                                alt="" />
                            <h2 className="text-[#0a1a42] font-bold">Rev. Mrs. Nches Iredu</h2>
                        </div>


                        <div className="text-[#0a1a42] md:text-left mt-4 md:mt-8 md:w-3/4">
                            <h1 className="font-bold text-2xl">From the Executive Director</h1>
                            <h2 className="font-semibold text-4xl">Welcome to DRIC!</h2>
                            <p className="text-[18px] leading-8">
                                As our core values re present, we create a strong mix of moral discipline,
                                attitudinal reformation, technologically supported learning experience, and
                                a personalized support system that prepares every child for a successful career
                                and life from day one. Over the years, we have leveraged our stimulating and
                                conducive learning environment, to make learning much easier and also create an
                                enabling atmosphere where students can feel free to express their passion, identify
                                their unique abilities, and learn how to use these potentials to create wealth and
                                become drivers of positive change in their generation. Our Nigerian-British
                                curriculum provides a trans-border comparative and competitive
                                advantage for our students, re-emphasizing our mission to produce
                                the total child in character and learning through the provision of
                                qualitative formal education combined with the right Christian ethics
                                and principles.
                            </p>
                        </div>

                    </div>




                    <section class="text-[#0a1a42] mt-4 md:mt-8 body-font">
                        <div class="container mx-auto flex px-5 py-12 md:flex-row flex-col items-center">
                            <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-8 md:mb-0 items-center text-center">
                                <h1 class="title-font sm:text-4xl text-3xl mb-4 text-[#0a1a42] font-roboto font-bold ">Take an Entrance Exam Online
                                    <br class="hidden lg:inline-block" />
                                </h1>
                                <p class="mb-4 leading-relaxed">
                                    Copper mug try-hard pitchfork pour-over freegan heirloom neutra air plant cold-pressed tacos poke beard tote bag. Heirloom echo park mlkshk tote bag selvage hot chicken authentic tumeric truffaut hexagon try-hard chambray.
                                </p>
                                <div class="flex justify-center">
                                    <button class="ml-4 inline-flex text-gray-700 bg-[#f7951e] border-0 py-2 px-6 focus:outline-none hover:bg-[#f7951e] hover:text-white rounded text-lg">Take an Exam</button>
                                </div>
                            </div>
                            <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
                                <img class="object-cover object-center rounded" alt="hero" src="/schoolweb/exam.webp" />
                            </div>
                        </div>
                    </section>



                    <div className="mt-12">
                        <h1
                            tyle={{
                                width: '100%',
                                height: '40px',
                                scrollBehavior: 'alternate',
                                direction: 'right',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                            }}
                            className="text-center text-[#0a1a42] font-serif font-bold text-2xl">Educational Affiliations</h1>
                        <marquee>
                            <div className="flex">
                                <img src="/schoolweb/marquee/1.webp" alt="" />
                                <img src="/schoolweb/marquee/2.webp" alt="" />
                                <img src="/schoolweb/marquee/3.webp" alt="" />
                                <img src="/schoolweb/marquee/4.webp" alt="" />
                            </div>

                        </marquee>

                        <div>

                        </div>
                    </div>

                    <div className="pt-8 md:mt-24">
                        <h1 className="text-[#0a1a42] text-2xl font-bold text-center">School Awards </h1>
                        <span className="">
                            <BsAwardFill className="mx-auto mt-4 block text-[60px] text-[#f7951e]" />
                        </span>

                    </div>

                    <div className="px-8 pt-8 pb-8 mt-12 md:mt-24">
                        <h3 className="font-semibold text-2xl text-[#f7951e]">FAQ</h3>
                        <h1 className="text-[#0a1a42] text-xl font-bold font-serif">
                            Common Inquiries Parents Have about Divine Royal
                        </h1>
                        <h4 className="pb-4">
                            We've answered some of the most common questions parents have about us.
                        </h4>
                        <div >
                            <Faq />
                        </div>
                    </div>

                </Layout>
            )}
        </>
    );
}

export default Home;